export default {"src":"/_next/static/media/icon-username-search.ffe1bf3c.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};